module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', {
    attrs: {
      "no_back": "true",
      "settings": "systemZoom"
    }
  }, [_vm._v("esma")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "30px"
    }
  }, [_c('div', {
    staticClass: "col-xs-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.col1), function(c) {
    return _c('router-link', {
      key: c.name,
      staticClass: "btn btn-primary btn-lg",
      staticStyle: {
        "margin": "5px",
        "width": "80%",
        "background": "#5a99d2",
        "color": "white",
        "font-weight": "bold"
      },
      attrs: {
        "disabled": c.path == '#' || c.disabled,
        "tag": "button",
        "to": c.path,
        "type": "button"
      }
    }, [_vm._v(_vm._s(c.name))])
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.col2), function(c) {
    return _c('router-link', {
      key: c.name,
      staticClass: "btn btn-primary btn-lg",
      staticStyle: {
        "margin": "5px",
        "width": "80%",
        "background": "#5a99d2",
        "color": "white",
        "font-weight": "bold"
      },
      attrs: {
        "disabled": c.path == '#' || c.disabled,
        "tag": "button",
        "to": c.path,
        "type": "button"
      }
    }, [_vm._v(_vm._s(c.name))])
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "30px"
    }
  }, [_c('div', {
    staticClass: "col-xs-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('h2', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("棚卸メニュー")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80f03340","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/menu_inventory.vue
// module id = 1042
// module chunks = 0